import { applyMiddleware, combineReducers, createStore } from "redux";
import { appMiddleware } from "./middlewares/app";
import { apiMiddleware } from "./middlewares/core";
import { asyncMiddleware } from "./middlewares/async";

import { composeWithDevTools } from "redux-devtools-extension";

import monitorReducersEnhancer from "./enhancers/monitorReducer";
import loggerMiddleware from "./middlewares/logger";
import rootReducer from "./reducers/rootReducer";
import vtrListReducer from "./reducers/vtrListReducer";
import ivrListReducer from "./reducers/ivrListReducer";
import validationReducer from "./reducers/validationReducer";
import newTripReducer from "./reducers/newTripReducer";
import helpTextReducer from "./reducers/helpTextReducer";
import { errorReducer } from "./reducers/errorReducer";

export default function configureStore(preloadedState) {
  const middlewares = [asyncMiddleware, loggerMiddleware, appMiddleware, apiMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer, monitorReducersEnhancer];
  const composedEnhancers = composeWithDevTools(...enhancers);

  const reducers = combineReducers({
    auth: rootReducer,
    vtrList: vtrListReducer,
    ivrList: ivrListReducer,
    validation: validationReducer,
    vtrTrip: newTripReducer,
    helpText: helpTextReducer,
    error: errorReducer,
  });
  return createStore(reducers, preloadedState, composedEnhancers);
}
